module.exports = __webpack_public_path__ + "static/img/roland_ph_02.958f04a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/roland_ph_02.png
// module id = gekB
// module chunks = 0